import { useEffect } from 'react'

/**
 * Run an effect exactly once on mount, syncing with an external system.
 *
 * This is the only approved escape hatch for `useEffect` usage. Prefer:
 * - Derived state: compute inline instead of effect-based syncing
 * - Event handlers: do the work in the handler, not a triggered effect
 * - React Query: for data fetching
 *
 * @param effect - Effect function to run on mount (may return a cleanup function).
 */
export function useMountEffect(effect: () => void | (() => void)): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, [])
}
